import { RESET_EDIT_USER } from '../types'
export const resetedituser = () => {

    return (dispatch) => {
        dispatch({ type: RESET_EDIT_USER });
    }
}